import { render } from "./ModalContent.vue?vue&type=template&id=1b30ac85"
import script from "./ModalContent.vue?vue&type=script&lang=js"
export * from "./ModalContent.vue?vue&type=script&lang=js"

import "./ModalContent.vue?vue&type=style&index=0&id=1b30ac85&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__